import React from "react";
import "./error.scss";
import ErrorSvg from "./img/Error.svg";

const Error = () => {
  return (
    <div className="section error-container">
      <img src={ErrorSvg} alt="error" />
    </div>
  );
};

export default Error;
